<div class="dialog-wrapper access-content">
	<h1 mat-dialog-title>De betaling van je Membership is mislukt!</h1>
	<div mat-dialog-content>
		Voorkom oplopende kosten. Klik op de button hieronder om je betaling in orde te maken en je toegang te behouden.
	</div>
	<div mat-dialog-actions>
		<button type="button" class="btn primary" mat-dialog-close cdkFocusInitial (click)="goMembership()">
			<span class="button-text">Nu betalen</span>

			<span class="button-icon">
				<fa-icon matSuffix [icon]="['fas', 'arrow-right-long']"></fa-icon>
			</span>
		</button>
	</div>

	<button mat-icon-button class="close-dialog" [mat-dialog-close]="true">
		<fa-icon class="close-icon" matSuffix [icon]="['fas', 'times']"></fa-icon>
	</button>
</div>